import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { Form } from 'react-bootstrap';
// import Select from 'react-select';
import FormPassword from '../FormPassword';
import {
  fileSizeValidator,
  fileTypeValidator,
  isRequiredValidator,
  maxFilesValidator
} from '../../_helpers/validationFunctions';
import FormError from '../FormError';
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  StyledFormGroup,
  StyledFormLabel
} from '../Reuseables';
import DatePickerNepali from '../DatePickerNepali';
import { FormattedMessage } from 'react-intl';
import { StyledSelect } from './Components';
import FormEditor from '../FormEditor';
import TextareaAutosize from 'react-textarea-autosize';

export const FormGroup = ({
  id,
  errorId,
  errorName,
  label,
  type,
  fileType,
  labelClassName = '',
  info,
  register,
  disabled,
  defaultValue,
  error,
  placeholder,
  options,
  onChange,
  required,
  lessThan,
  min,
  checked,
  max,
  acceptedFormats,
  isMulti,
  isValidate = true,
  maxSelected,
  className,
  passwordType,
  readOnly,
  step
}) => {
  let validation = { validate: {} };
  let innerComponent;
  if (required) {
    if (type === 'file') {
      if (errorId) {
        validation.required = <FormattedMessage id={`${errorId}.required`} />;
      } else {
        validation.validate.required = (files) =>
          isRequiredValidator(defaultValue, files, errorName, id);
        // validation.required = `${errorName || id} is required.`;
      }
      validation.validate.required = (files) =>
        isRequiredValidator(defaultValue, files, errorName, id);
    } else {
      if (errorId) {
        validation.required = <FormattedMessage id={`${errorId}.required`} />;
      } else {
        validation.required = `${errorName || id} is required.`;
      }
    }
  }
  if (lessThan) {
    validation.validate.lessThan = (files) =>
      lessThan && fileSizeValidator(Boolean(defaultValue), lessThan, files);
  }
  if (acceptedFormats?.length) {
    validation.validate.acceptedFormats = (files) =>
      fileTypeValidator(Boolean(defaultValue), acceptedFormats, files);
  }
  if (maxSelected) {
    validation.validate.maxSelected = (files) =>
      maxFilesValidator(Boolean(defaultValue), maxSelected, files);
  }
  switch (type) {
    case 'text':
    case 'email':
    case 'number':
      innerComponent = (
        <Form.Control
          type={type}
          placeholder={placeholder}
          defaultValue={defaultValue}
          {...register(id, isValidate && validation)}
          min={min}
          max={max}
          maxLength={max}
          onKeyPress={(evt) => {
            if (min === 0) {
              if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
                evt.preventDefault();
              }
            }
          }}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            register(id).onChange(e);
          }}
          step={step}
          disabled={disabled}
          readOnly={readOnly}
        />
      );
      break;

    case 'password':
      innerComponent = (
        <FormPassword
          placeholder={placeholder}
          register={register}
          id={id}
          maxLength={max}
          passwordType={passwordType}
          isValidate={isValidate}
          validation={validation}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            register(id).onChange(e);
          }}
          disabled={disabled}
          defaultValue={defaultValue}
        />
      );
      break;
    case 'textarea':
      innerComponent = (
        <TextareaAutosize
          as={type}
          placeholder={placeholder}
          {...register(id, validation)}
          disabled={disabled}
          defaultValue={defaultValue}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            register(id).onChange(e);
          }}
          className="text-area-autoresize"
          minRows={5}
          readOnly={readOnly}
        />
      );
      break;
    case 'file':
      innerComponent = (
        <Fragment>
          {defaultValue && (
            <div>
              {fileType === 'audio' ? (
                <audio controls controlsList="nodownload">
                  <source src={`${defaultValue}`} type="audio/mp3" />
                </audio>
              ) : (
                <Fragment>
                  {typeof defaultValue === 'string' ? (
                    <img
                      onClick={() => window.open(defaultValue, '_blank')}
                      src={defaultValue}
                      className="my-2"
                      style={{
                        width: '50px',
                        height: '50px',
                        objectFit: 'cover',
                        borderRadius: '50%'
                      }}
                      alt=""
                    />
                  ) : (
                    defaultValue.map((imgSrc) => (
                      <img
                        onClick={() => window.open(imgSrc, '_blank')}
                        key={imgSrc}
                        src={imgSrc}
                        className="my-2"
                        style={{
                          width: '50px',
                          height: '50px',
                          objectFit: 'cover',
                          borderRadius: '50%'
                        }}
                        alt=""
                      />
                    ))
                  )}
                </Fragment>
              )}
            </div>
          )}
          <FileInput>
            <Form.Control
              id={id}
              type="file"
              accept={(acceptedFormats || []).reduce((acc, cur) => (acc += cur + ','), '')}
              multiple={isMulti}
              disabled={disabled}
              {...register(id, validation)}
              onChange={(e) => {
                register(id).onChange(e);
                if (onChange) {
                  onChange(e);
                }
              }}
            />
          </FileInput>
        </Fragment>
      );
      break;
    case 'select':
      innerComponent = (
        <Fragment>
          <StyledSelect
            id={id}
            key={defaultValue?.value}
            options={options}
            placeholder={placeholder}
            onChange={(e) => onChange(e)}
            defaultValue={defaultValue}
            isDisabled={disabled}
            isMulti={isMulti}
            readOnly={readOnly}
          />
          <input type="text" {...((register && register(id, validation)) || {})} readOnly hidden />
        </Fragment>
      );
      break;
    case 'editor':
      innerComponent = (
        <FormEditor disabled={disabled} defaultValue={defaultValue} onChange={onChange} />
      );
      break;
    case 'radio':
      innerComponent = (
        <RadioInput>
          {options?.map((option) => (
            <Fragment key={`${option.id}_${defaultValue}`}>
              <Form.Check
                key={option.id}
                id={option.id}
                value={option.value}
                type="radio"
                name={option.name}
                label={option.label}
                {...register(id, isValidate && validation)}
                onChange={(e) => {
                  if (onChange) {
                    onChange(e);
                  }
                  register(id).onChange(e);
                }}
                defaultChecked={defaultValue === option.value}
                readOnly={readOnly}
              />
            </Fragment>
          ))}
        </RadioInput>
      );
      break;
    case 'checkbox':
      // eslint-disable-next-line no-case-declarations
      const rest = {};
      if (checked !== undefined) {
        rest.checked = checked;
      }
      innerComponent = (
        <Fragment>
          <CheckBoxInput className={className}>
            {options?.map((option) => {
              if (defaultValue) {
                rest.defaultChecked = (defaultValue || []).includes(String(option.value));
              }
              return (
                <Form.Check
                  key={option.id}
                  id={option.id}
                  value={option.value}
                  type="checkbox"
                  label={option.label}
                  {...register(id, isValidate && validation)}
                  onChange={(e) => {
                    if (onChange) {
                      onChange(e);
                    }
                    register(id).onChange(e);
                  }}
                  {...rest}
                  disabled={disabled}
                  // defaultChecked={true}
                  // defaultChecked={(defaultValue || []).includes(String(option.value))}
                  readOnly={readOnly}
                />
              );
            })}
          </CheckBoxInput>
        </Fragment>
      );
      break;
    case 'nepali_date':
      innerComponent = (
        <Fragment>
          <DatePickerNepali
            register={register}
            id={id}
            validation={validation}
            defaultValue={defaultValue}
            onChange={onChange}
          />
        </Fragment>
      );
      break;
    case 'year':
      innerComponent = (
        <Fragment>
          <Form.Control
            type={type}
            placeholder={placeholder}
            {...register(id, isValidate && validation)}
            onChange={onChange}
            disabled={disabled}
            defaultValue={defaultValue}
          />
        </Fragment>
      );
      break;
    case 'color':
      innerComponent = (
        <Fragment>
          <Form.Control
            type={type}
            placeholder={placeholder}
            {...register(id, isValidate && validation)}
            onChange={onChange}
            disabled={disabled}
            defaultValue={defaultValue}
            readOnly={readOnly}
          />
        </Fragment>
      );
      break;
    default:
      innerComponent = <div>Invalid Component</div>;
  }

  return (
    <StyledFormGroup className={`styledformgroup ${className ? className : ''}`}>
      {label && (
        <StyledFormLabel>
          <span className={`label-text ${labelClassName ? labelClassName : ''} `}>{label}</span>
          {info && <span className="info">{info}</span>}
        </StyledFormLabel>
      )}

      {innerComponent}
      {error && <FormError error={error[id]} />}
    </StyledFormGroup>
  );
};

FormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  info: PropTypes.string,
  type: PropTypes.string.isRequired,
  fileType: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool,
    PropTypes.number
  ]),
  error: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  lessThan: PropTypes.number,
  acceptedFormats: PropTypes.array,
  isMulti: PropTypes.bool,
  isValidate: PropTypes.bool
};
